var _a, _b;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import template from './actionsOptionList.view.html';
import { AiAgentSidebarStateService } from '../../../../aiAgent/services/AiAgentSidebarStateService';
import { ActionFeatures } from '../../ActionFeatures';
import { CurrentApplicationService } from 'modules/shared/CurrentApplicationService';
import { BuilderFeatures } from '../../../../BuilderFeatures';
let ActionsOptionListComponent = class ActionsOptionListComponent {
    static $inject = ['AiAgentSidebarStateService', 'CurrentApplicationService'];
    constructor(AiAgentSidebarStateService, CurrentApplicationService) {
        this.AiAgentSidebarStateService = AiAgentSidebarStateService;
        this.CurrentApplicationService = CurrentApplicationService;
        //#region Binding
        this.isAiAgent = false;
        this.isSubflowApplication = false;
        this.hasGroundingToolsAccess = false;
        this.initFeatures();
    }
    async initFeatures() {
        this.isGroundingToolsEnabled = await BuilderFeatures.isStudioGroundingToolsEnabled();
        this.isProcessContentAssistantEnabled = await ActionFeatures.isActionProcessContentAssistantEnabled();
        try {
            this.isSubflowApplication = (await this.CurrentApplicationService.fetchApplication()).isSubflow;
        }
        catch {
            this.isSubflowApplication = true;
        }
    }
    $doCheck() {
        const data = this.AiAgentSidebarStateService.getData();
        if (data) {
            this.addActionText = data.addActionText;
        }
    }
    $onDestroy() {
        this.AiAgentSidebarStateService.close();
    }
    onAddAction(type) {
        this.AiAgentSidebarStateService.getData()?.onAddAction(type);
        this.onClose();
    }
    onClose() {
        this.AiAgentSidebarStateService.close();
    }
};
// #endregion
ActionsOptionListComponent.$inject = ['AiAgentSidebarStateService', 'CurrentApplicationService'];
ActionsOptionListComponent = __decorate([
    Component({
        template,
        bindings: {
            isAiAgent: '<?',
            hasGroundingToolsAccess: '<?'
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof AiAgentSidebarStateService !== "undefined" && AiAgentSidebarStateService) === "function" ? _a : Object, typeof (_b = typeof CurrentApplicationService !== "undefined" && CurrentApplicationService) === "function" ? _b : Object])
], ActionsOptionListComponent);
export { ActionsOptionListComponent };
